// utilities used for page layout and ui messages
export function firstColumnInTwo (arr) {
  if (arr.length <= 2) return arr

  let mid = Math.ceil(arr.length / 2)
  return arr.slice(0, mid)
}

export function secondColumnInTwo (arr) {
  if (arr.length <= 2) return null

  let mid = Math.ceil(arr.length / 2)
  return arr.slice(mid, arr.length)
}

export function firstColumnInThree (arr) {
  if (arr.length <= 2) return arr
  if (arr.length <= 4) return arr.slice(0, 2)

  let third1 = Math.ceil(arr.length / 3)
  return arr.slice(0, third1)
}

export function secondColumnInThree (arr) {
  if (arr.length <= 2) return null
  if (arr.length <= 4) return arr.slice(2, arr.length)

  let third1 = Math.ceil(arr.length / 3)
  let third2 = Math.ceil(arr.length / 3) * 2
  return arr.slice(third1, third2)
}

export function thirdColumnInThree (arr) {
  if (arr.length <= 4) return null

  let third2 = Math.ceil(arr.length / 3) * 2
  return arr.slice(third2, arr.length)
}

export function toURL (label) {
  return label.replace(/\W+/g, '-').replace(/-+$/, '').toLowerCase()
}

export function capitalizeFirstChars (str) {
  var words = str.split(' ')
  for (let i = 0; i < words.length; i++) {
    words[i] = words[i][0].toUpperCase() + words[i].substr(1)
  }
  return words.join(' ')
}

export function cssPersonalized (color) {
  var r = parseInt(color.slice(1, 3), 16)
  var g = parseInt(color.slice(3, 5), 16)
  var b = parseInt(color.slice(5, 7), 16)

  return 'background: ' + 'rgba(' + r + ',' + g + ',' + b + ', 0.2);'
}

export function isEmpty (value) {
  if (typeof value === 'number') return value === null

  // real empty input + incomplete numerical expression input
  // incomplete numerical expressions are not displayed on screen,
  // yet  in the data bound (see HOWTO-bug.txt).
  var trimmed = !value ? null : value.trim()
  return (
    !trimmed || trimmed.length === 0 ||
    trimmed === '+' || trimmed === '-' || trimmed === '.' || trimmed === 'e'
  )
}

export function shuffleArray (array, n = null) {
  // shuffle the first n items in array
  let maxindex = n ? n - 1 : array.length - 1
  for (let i = maxindex; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let t = array[i]; array[i] = array[j]; array[j] = t
  }
  return array
}

export function variableLetter () {
  const variables = [
    'a', 'b', 'c', 'd', 'f',
    'g', 'h', 'k', 'm', 'n',
    'p', 'q', 'r', 's', 't',
    'v', 'w', 'x', 'y', 'z'
  ]
  return variables[Math.floor(Math.random() * variables.length)]
}

export function msgCorrect () {
  const msgCorrect = [
    'Right!',
    'Great!',
    'Correct!',
    'Perfect!',
    'Excellent!',
    'Good job!',
    'Nice work!',
    'You are correct!'
  ]
  return msgCorrect[Math.floor(Math.random() * msgCorrect.length)]
}

export function msgWrong () {
  const msgWrong = [
    'Oops!',
    'Sorry!',
    'Not correct.',
    'Sorry, incorrect.',
    'That\'s not corrrect.'
  ]
  return msgWrong[Math.floor(Math.random() * msgWrong.length)]
}



// WEBPACK FOOTER //
// ./src/common/js/uiutil.js